import { render } from "./RecommendationInstructions.vue?vue&type=template&id=d94b7170"
import script from "./RecommendationInstructions.vue?vue&type=script&lang=js"
export * from "./RecommendationInstructions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__